import { testimonialsData } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section id="testimonials" className="py-20 md:py-28 bg-carland-light">
      <div className="px-6 md:px-12 lg:px-20">
        {/* Header */}
        <div className="text-right mb-12">
          <span className="text-carland-muted text-sm font-medium tracking-wider">
            تجربه کاربران
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-carland-dark mt-3 leading-tight">
            آن‌ها که به ما اعتماد کردند
          </h2>
          <p className="text-carland-muted text-sm md:text-base text-right max-w-xl mt-3">
            بیش از ۴۷,۰۰۰ کارجوی موفق که نظرشان درباره کارلند را با ما به اشتراک گذاشته‌اند
          </p>
        </div>

        {/* Grid of all testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonialsData.map((t) => (
            <div
              key={t.id}
              className="bg-white rounded-2xl p-5 md:p-6 flex flex-col transition-all duration-300 hover:bg-carland-dark hover:text-white group cursor-default"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star} className={star <= Math.floor(t.rating) ? 'text-amber-500' : star <= t.rating ? 'text-amber-500' : 'text-carland-beige/50'}>
                    <i className={`text-sm ${star <= Math.floor(t.rating) ? 'ri-star-fill' : star <= t.rating ? 'ri-star-half-fill' : 'ri-star-line'}`}></i>
                  </span>
                ))}
                <span className="text-xs font-bold text-carland-dark/50 group-hover:text-white/60 mr-1.5 transition-colors">{t.rating}</span>
              </div>

              {/* Quote */}
              <p className="text-sm leading-relaxed text-carland-dark/75 group-hover:text-white/80 mb-5 flex-1 transition-colors">
                {t.quote}
              </p>

              {/* Author */}
              <div className="border-t border-carland-beige/30 group-hover:border-white/20 pt-3 transition-colors">
                <p className="font-bold text-sm text-carland-dark group-hover:text-white transition-colors">{t.name}</p>
                <p className="text-xs text-carland-muted group-hover:text-white/60 transition-colors mt-0.5">{t.role}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Summary Bar */}
        <div className="mt-12 pt-8 border-t border-carland-beige/40">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-center">
            <div className="flex items-center gap-2">
              <span className="text-3xl md:text-4xl font-black text-carland-dark">۴.۹</span>
              <div className="flex items-center gap-0.5 text-amber-500">
                <i className="ri-star-fill text-lg"></i>
                <i className="ri-star-fill text-lg"></i>
                <i className="ri-star-fill text-lg"></i>
                <i className="ri-star-fill text-lg"></i>
                <i className="ri-star-half-fill text-lg"></i>
              </div>
            </div>
            <span className="hidden sm:block w-px h-8 bg-carland-beige"></span>
            <span className="text-carland-muted text-sm">
              بر اساس نظر <strong className="text-carland-dark">۴۷,۰۰۰+</strong> کارجوی موفق
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}